import axios from "axios";
import { config } from "../config/index";

const getCookie = (name) => {
    if (typeof document === "undefined") {
        return null;
    }
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
        return parts.pop().split(";").shift();
    }
    return null;
};

const instance2 = axios.create({
    baseURL: config.baseNewUrl
});

instance2.interceptors.request.use((requestConfig) => {
    const token = getCookie("apinew-token");
    if (token) {
        requestConfig.headers = requestConfig.headers || {};
        requestConfig.headers.Authorization = `Bearer ${token}`;
        requestConfig.withCredentials = true;
    }
    return requestConfig;
});

export default instance2;
